var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leftnav",style:('height:'+ (_vm.innerHeight-60)+'px;')},[_c('ul',[_c('li',{staticClass:"home_icon"},[_c('router-link',{attrs:{"to":"/Home"}},[_c('img',{attrs:{"src":require("../assets/images/shouye.png")}}),_vm._v("首页")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.3.0@vue-loader/lib/template-compiler?{"id":"data-v-3be305d8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/leftNav.vue
// module id = zxKC
// module chunks = 1